import { render } from "./SupportSection.vue?vue&type=template&id=027acb97"
import script from "./SupportSection.vue?vue&type=script&lang=js"
export * from "./SupportSection.vue?vue&type=script&lang=js"

import "./SupportSection.vue?vue&type=style&index=0&id=027acb97&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__